import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { spacesKeys } from 'src/features/spaces/api/query-keys/spaces';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { unassignSpaceFromSpaceGroup } from '../lib/space-groups';
import { UnassignSpaceFromSpaceGroupPayload } from '../types/payload/unassign-space-from-space-group.payload';

export const useUnassignSpaceFromSpaceGroup = (onSuccess?: () => void) => {
  const { t } = useTranslation(['spaceGroups', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UnassignSpaceFromSpaceGroupPayload) =>
      unassignSpaceFromSpaceGroup(payload),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: spacesKeys.lists(),
        });
      });
      toast.success(t('spaceGroups:details.removeFromGroupDialog.success'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages.somethingWentWrong'),
      );
    },
  });
};
